import React, { useEffect, useRef } from 'react';
import PrivacyPolicy, { PrivacyPolicyText } from '../../../components/PrivacyPolicy';
import { isMobileOidc } from '../../../utilities/oidc/oidc';
import { useRegisterComponent } from '../../orchestrator';
import { pageId } from '../constants';
import { useSignupPageContext } from '../contexts/SignupPageContext';
import { useAppSelector } from '../../../stores/redux.store';

export const SignupPrivacyPolicy = () => {
  useRegisterComponent(SignupPrivacyPolicy.name);

  const privacyPolicyMessageRef = useRef<HTMLParagraphElement>(null);

  const isEmbedded = useAppSelector(state => state.microbranding?.isEmbedded);
  const oidcContext = useAppSelector(state => state.microbranding?.oidcContext);

  const { setPrivacyPolicyText } = useSignupPageContext();

  useEffect(() => {
    const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';

    if (privacyPolicyText) {
      setPrivacyPolicyText(privacyPolicyText);
    }
  }, [privacyPolicyMessageRef.current?.innerHTML, setPrivacyPolicyText]);

  return (
    <PrivacyPolicy
      isEmbedded={isEmbedded}
      isMobileOidc={isMobileOidc(oidcContext)}
      pageId={pageId}
      privacyPolicyText={PrivacyPolicyText.passwordSignup}
      ref={privacyPolicyMessageRef}
    />
  );
};
